// Centralized constants for graph behavior and filtering
export const MAX_FILTER_TERMS = 10;

// Canonical root node id used across the codebase
export const QUALITY_ROOT_ID = "quality-root";

// Canonical node type strings
export const NODE_TYPES = Object.freeze({
  QUALITY: "quality",
  REQUIREMENT: "requirement",
  STANDARD: "standard",
  APPROACH: "approach",
  PROPERTY: "property", // kept for backward compat
  DIMENSION: "dimension",
});
